import React, { useEffect, useState, useContext } from 'react'
import { toast } from 'react-toastify';
import PageHeader from '../../components/pageHeader/PageHeader';
import PageWrapper from '../../components/pageComponents/PageWrapper';
import SearchContainer from '../../components/pageComponents/SearchContainer';
import TablePrestamosYAdelantos from './TablePrestamosYAdelantos';
import styled from "styled-components"; 
import {responseCode200} from "../../consumers/httpRequiestsUtils";  
import {getAllEstadosToPrestamoAPI, getAllTipoSolicitudPrestamoAPI, getListaSolicitudesPrestamoAPI, getEsPeriodoPermitidoAPI,
    getAllEstadosEmpleadoToPrestamoAPI, getAllNivelesToPrestamoAPI,
    getAllCargosToPrestamoAPI, getAllSedesToPrestamoAPI, getAllDepartamentosToPrestamoAPI,
    getAllTipoMotivosPrestamoAPI
} from '../../consumers/backendApisUrls';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import {initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData, usuarioLogueadoTieneAlgunoDeLosSiguientesRoles} from "../../helper/utils";
import SolicitarPrestamo from "./modales/SolicitarPrestamo";
import LineamientosPrestamo from './modales/LineamientosPrestamo';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { AuthContext } from '../../hooks/context/authContext';
import { ROLES } from '../../constants/hardCodedConstants';

const INIT_KEYS = {
    IdsEstadoEmpleado : "IdsEstadoEmpleado",
    IdsCargosPrestamo : "IdsCargosPrestamo",
    IdsSedesPrestamo : "IdsSedesPrestamo",
    IdsDepartamentosPrestamo : "IdsDepartamentosPrestamo",
    IdsTipoSolicitudPrestamo : "IdsTipoSolicitudPrestamo",
    IdsEstadoProceso: "IdsEstadoProceso",
    IdsNivelesPrestamo : "IdsNivelesPrestamo",
    IdsMotivosPrestamo : "IdsMotivosPrestamo"
}

const MisPrestamosYAdelantos = () => {
    const { state } = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(true);
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [allFilters, setAllFilters] = useState([]);
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [executeGet] = useGetRequest();
    const [showModalCrearSolicitudPrestamo, setShowModalCrearSolicitudPrestamo] = useState(false);
    const [showLineamientos, setShowLineamientos] = useState(false);
    const [managePostRequest] = useManagePostRequest();
    const [rolGestionDePrestamos, setRolGestionDePrestamos] = useState(false);
    const [rolLiderEquipo, setRolLiderEquipo] = useState();
    const [rolDirector, setRolDirector] = useState();

    const initialPromises = () => [
        executeGet(getAllEstadosEmpleadoToPrestamoAPI()),
        executeGet(getAllCargosToPrestamoAPI()),
        executeGet(getAllSedesToPrestamoAPI()),
        executeGet(getAllDepartamentosToPrestamoAPI()),
        executeGet(getAllTipoSolicitudPrestamoAPI()),
        executeGet(getAllEstadosToPrestamoAPI()),
        executeGet(getAllNivelesToPrestamoAPI()),
        executeGet(getAllTipoMotivosPrestamoAPI())
    ]

    useEffect(() => {
        init();
    }, [])

    const init = async () => {
        setIsLoading(true);
        setRolGestionDePrestamos(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.GestionPrestamosYAdelantos.id]));
        setRolLiderEquipo(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.LiderEquipo.id]));
        setRolDirector(usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.DirectorDeColegio.id]));
        await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
        await manageSearch();
        setIsLoading(false);
    }

    const manageSearch = async () => {
        try{
            setIsLoading(true);
            const api = getListaSolicitudesPrestamoAPI();
            const payload = getPayload();
            await managePostRequest(api, payload, successManageSearchCallback);
        }catch(error){
            console.error(error);
        }finally{
            setIsLoading(false);
        }                
    }
    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            ...formValues.selectedFilters
        }
    }
    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
    }
    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    const toggleCrearSolicitudPrestamo = () => {
        setShowModalCrearSolicitudPrestamo(!showModalCrearSolicitudPrestamo);
    };

    const manageSearchProxy = (response) => {
        manageSearch();
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleAbrirSolicitud = async () => {
        const responsePeriodo = await executeGet(getEsPeriodoPermitidoAPI());
        if (responseCode200(responsePeriodo) && !responsePeriodo.data) {
            console.log(responsePeriodo.data);
            toast.warn("No es posible registrar solicitudes en este período.");
            return; 
        }
        toggleCrearSolicitudPrestamo(); 
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        formValues.ExtraData && jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    return (
        <>
        {showModalCrearSolicitudPrestamo && 
        <div className="modal-contactanos modal-response-ficha-background">	
            <SolicitarPrestamo showModal={toggleCrearSolicitudPrestamo} 
                refreshPage={manageSearch} fromAdminPage={false} esGestorPrestamos={false} />
        </div>
        }
        {showLineamientos && (
            <div className="modal-contactanos modal-response-ficha-background">	            
                <LineamientosPrestamo showModal={() => setShowLineamientos(false)} />
            </div>
        )}
        <PageWrapper isLoading={isLoading}>
            <PageHeader title="Mis Préstamos y Adelantos"/>

            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>

                    <ButtonsWrapper>
                        <div className="d-flex">
                            <button type='button' 
                            className='generic-button-buscador' 
                            onClick={handleAbrirSolicitud}>Solicitar aquí</button> 

                            <button type='button' 
                            className='generic-button-buscador' 
                            onClick={() => setShowLineamientos(true)}>Ver lineamientos</button>
                        </div>
                        
                    </ButtonsWrapper>
            </SearchContainer>

            <TablePrestamosYAdelantos
                formValues={formValues}
                setFormValues={setFormValues}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                fromAdminPage={false}
                manageSearch={manageSearchProxy}
                rolGestionDePrestamos={rolGestionDePrestamos}
                rolLiderEquipo={rolLiderEquipo}
                rolDirector={rolDirector}
            >

            </TablePrestamosYAdelantos>

        </PageWrapper>
        </>
    )
}
export default MisPrestamosYAdelantos



const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;